import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlidersHorizontal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.02809 5.9375H3.125C2.77982 5.9375 2.5 6.21732 2.5 6.5625C2.5 6.90768 2.77982 7.1875 3.125 7.1875H6.02809C6.29701 8.09109 7.13406 8.75 8.125 8.75C9.11594 8.75 9.95299 8.09109 10.2219 7.1875H16.875C17.2202 7.1875 17.5 6.90768 17.5 6.5625C17.5 6.21732 17.2202 5.9375 16.875 5.9375H10.2219C9.95299 5.03391 9.11594 4.375 8.125 4.375C7.13406 4.375 6.29701 5.03391 6.02809 5.9375ZM7.1875 6.5625C7.1875 6.04473 7.60723 5.625 8.125 5.625C8.64277 5.625 9.0625 6.04473 9.0625 6.5625C9.0625 7.08027 8.64277 7.5 8.125 7.5C7.60723 7.5 7.1875 7.08027 7.1875 6.5625Z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.125 12.8125H11.0281C11.297 11.9089 12.1341 11.25 13.125 11.25C14.1159 11.25 14.953 11.9089 15.2219 12.8125H16.875C17.2202 12.8125 17.5 13.0923 17.5 13.4375C17.5 13.7827 17.2202 14.0625 16.875 14.0625H15.2219C14.953 14.9661 14.1159 15.625 13.125 15.625C12.1341 15.625 11.297 14.9661 11.0281 14.0625H3.125C2.77982 14.0625 2.5 13.7827 2.5 13.4375C2.5 13.0923 2.77982 12.8125 3.125 12.8125ZM13.125 12.5C12.6072 12.5 12.1875 12.9197 12.1875 13.4375C12.1875 13.9553 12.6072 14.375 13.125 14.375C13.6428 14.375 14.0625 13.9553 14.0625 13.4375C14.0625 12.9197 13.6428 12.5 13.125 12.5Z"
	})]
});
export default SvgSlidersHorizontal;
